export function replaceExceptLastTwo(inputString) {
    if (inputString.length < 3) {
        return inputString; // Not enough characters to replace
    }

    const lastTwoChars = inputString.slice(-3);
    const replacedString = '*'.repeat(inputString.length - 3) + lastTwoChars;
    return replacedString;
}
